import { enum as enum_, literal, object, union } from "zod";

import environmentsConfig from "../../../../environments.json";

const environmentKeys = Object.keys(environmentsConfig.environments) as [string, ...string[]];

const unsafeEnv = {
  developmentMode: import.meta.env.VITE_DEVELOPMENT_MODE,
  mode: import.meta.env.DEV ? "dev" : "prod",
  environment: import.meta.env.VITE_ENVIRONMENT,
};

const envSchema = object({
  mode: union([literal("dev"), literal("prod")]).default("prod"),
  developmentMode: union([literal("remote-dev"), literal("flamykube")]).default("remote-dev"),
  // The supported values come from the repository-level environments.json,
  // which also drives the dev proxy and the Keycloak authority.
  environment: enum_(environmentKeys).default("kyc"),
});

const result = envSchema.safeParse(unsafeEnv);

if (!result.success) {
  throw new Error(`Invalid environment variables: ${result.error.message}`);
}

export const env = result.data;
